import { defineStore } from 'pinia';
import { bytesToBase64 } from '~/util/bytes';
/**
 * The signed-in user's own private key, opened from their vault with their
 * password (see `accountCrypto`). It opens the client organizations' keys
 * shared with them. Kept for the lifetime of this tab like the
 * organization keys (`sessionStorage`, gone when the tab closes), so a
 * reload doesn't ask for the password again.
 */
const STORAGE_KEY = 'zunox-account-key';
function readStored() {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    }
    catch {
        return null;
    }
}
function writeStored(value) {
    try {
        if (value === null)
            sessionStorage.removeItem(STORAGE_KEY);
        else
            sessionStorage.setItem(STORAGE_KEY, value);
    }
    catch {
        // The in-memory copy still works for this page load.
    }
}
export const useAccountStore = defineStore('account', {
    state: () => ({
        privateKeyBase64: readStored(),
    }),
    getters: {
        isVaultOpen(state) {
            return !!state.privateKeyBase64;
        },
    },
    actions: {
        openVault(privateKey) {
            this.privateKeyBase64 = bytesToBase64(privateKey);
            writeStored(this.privateKeyBase64);
        },
        closeVault() {
            this.privateKeyBase64 = null;
            writeStored(null);
        },
    },
});
